import { Space, Tag } from 'antd';
import dayjs from 'libs/dayjs';
import React from 'react';
import Badge from '../../components/global/Badge';
import HallazgoChip from '../../components/admin/Hallazgos/HallazgoChip';

export const getColumns = (props) => {
  const { buttonActionToggleState } = props;
  return [
    {
      title: 'Estado',
      key: 'status',
      render: (record) => <Badge color={record.status_color} />,
    },
    {
      title: 'Ascensores',
      key: 'elevator',
      dataIndex: 'elevator',
    },
    {
      title: 'Descripción',
      key: 'description',
      dataIndex: 'description',
    },
    {
      title: 'Hallazgo',
      key: 'hallazgo',
      render: (record) =>
        record.Hallazgo ? (
          <HallazgoChip hallazgo={record.Hallazgo} compact />
        ) : (
          <Tag color="default">Genérica</Tag>
        ),
    },
    {
      title: 'Última modificación',
      key: 'modified_date_item',
      dataIndex: 'modified_date_item',
      render: (date) => (date ? dayjs(date).format('YYYY-MM-DD HH:MM') : 'No modificado'),
    },
    {
      title: 'Acciones',
      key: 'check',
      render: (record) => (
        <Space>{buttonActionToggleState(record.item_status_id, record.id_item)}</Space>
      ),
    },
  ];
};

export const tabList = [
  {
    key: 'informacion',
    tab: 'Información',
  },
  {
    key: 'trabajo',
    tab: 'Trabajo',
  },
];
